import { FaQrcode } from 'react-icons/fa';
import PropTypes from 'prop-types';

/**
 * Filter button component.
 * 
 * @param {object} props
 * @param {string} props.id - button ID
 * @param {Function} props.action - function to run when the button is clicked
 */
const QRCodeButton = ({ id, action }) => {
    return (
        <button id={id} onClick={action}>
            {<FaQrcode />}
        </button>
    );
};

QRCodeButton.propTypes = {
    id: PropTypes.string.isRequired,
    action: PropTypes.func.isRequired,
};


export default QRCodeButton;
